<template>
  <div class="progress">
    <div class="banner"></div>
    <div class="profile">
      <div class="profile-header">
        <div class="title">
          <div class="cont_tit">
            <p>关于我们</p>
            <span>About Us</span>
          </div>
          <div class="crumb">
            <span>当前位置：</span>
            <a href="../" target="_self" title="首页" class="CurrChnlCls"
              >首页</a
            >&gt;<a href="" target="_self" title="关于我们" class="CurrChnlCls"
              >关于我们</a
            >&gt;<a target="_self" class="CurrChnlCls">{{
              Mode == 1
                ? "单位简介"
                : Mode == 2
                ? "组织架构"
                : Mode == 3
                ? "信息公开"
                : ""
            }}</a>
          </div>
        </div>
      </div>
      <div class="profile-conter">
        <ul class="job-tab">
          <li
            v-for="(item, index) in tabs"
            :key="index"
            class="tab-item"
            :class="{ 'item--active': Mode == index + 1 }"
            @click="toggleLoginMode(index + 1)"
          >
            {{ item }}
          </li>
        </ul>
      </div>
      <div class="resumeForm">
        <div v-if="Mode == 1">
          <group-profile></group-profile>
        </div>
        <div v-if="Mode == 2">
          <organizational-structure></organizational-structure>
        </div>
        <div v-if="Mode == 3">
          <information-disclosure></information-disclosure>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import store from "@/store";
export default {
  name: "aboutUs",
  data() {
    return {
      Mode: "",
      tabs: ["单位简介", "组织架构", "信息公开"]
    };
  },
  watch: {
    //监听路由地址的改变
    $route: {
      immediate: true,
      handler() {
        if (this.$route.query.aboutUsId) {
          //需要监听的参数
          this.Mode = this.$route.query.aboutUsId;
        }
      }
    },
    Mode(newVal) {
      this.updateRouteParams(newVal);
    },
  },
  methods: {
    toggleLoginMode(mode) {
      this.Mode = mode;
    },
    updateRouteParams(query) {
      if (query) {
        this.$router.push({
          path: "/aboutUs",
          query: { aboutUsId: query },
        });
      } else {
        this.$router.push({
          path: "/aboutUs",
          query: { aboutUsId: "1" },
        });
      }
      location.reload();
    },
  }
};
</script>
<style lang="less" scoped>
.banner {
  background-image: url("../assets/images/jrwmpc.png");
  background-size: 100% 100%;
  padding-bottom: 32%;
  background-repeat: no-repeat;
}
.profile {
  width: @main-width;
  margin: auto;
  &-header {
    padding-top: 50px;
    margin-bottom: 50px;
    .title {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .cont_tit {
      position: relative;
      font-weight: 800;
    }

    .cont_tit:after {
      content: "";
      position: absolute;
      background: url("../assets/images/index20231114_8.png") center center
        no-repeat;
      background-size: 100% auto;
      width: 450px;
      height: 56px;
      left: -10px;
      bottom: -30px;
    }

    .cont_tit p {
      display: inline-block;
      font-size: 30px;
      padding-right: 20px;
      line-height: 1.1;
      position: relative;
      margin-right: 20px;
      font-weight: 600;
      color: #335593;
    }

    .cont_tit p:after {
      content: "";
      position: absolute;
      height: 28px;
      width: 3px;
      left: 100%;
      bottom: 0;
      background: #7499ce;
    }

    .cont_tit span {
      display: inline-block;
      font-size: 14px;
      color: #b1b1b1;
    }

    .title .crumb {
      color: #585858;
      font-size: 18px;
    }

    .title .crumb a {
      margin: 0 10px;
      display: inline-block;
    }
  }
  &-conter {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 20px;
    .job-tab {
      align-items: center;
      border-bottom: 1px solid #7499ce;
      display: -ms-flexbox;
      display: flex;
      height: 62px;
      justify-content: space-around;
      line-height: 62px;
      margin-bottom: 10px;
      width: 100%;
      .tab-item {
        cursor: pointer;
        display: block;
        font-size: 18px;
        font-weight: 500;
        height: 62px;
        line-height: 62px;
        position: relative;
      }
      .tab-item.item--active {
        color: #7499ce;
        font-weight: bold;
      }
      .tab-item.item--active:after {
        content: "";
        position: absolute;
        width: 18px;
        height: 18px;
        border-color: #7499ce #7499ce #fff #fff;
        border-style: solid;
        border-width: 1px;
        top: calc(100% - 0.49em);
        left: 50%;
        background: #fff;
        transform: rotate(-45deg) translateX(-50%) translateY(-50%);
      }
    }
  }
  .resumeForm {
    margin: 20px 0;
    background: #fff;
    box-shadow: 0px 9px 20px 0px #c2c1c180;
    border-radius: 4px;
    padding: 30px;
  }
}
</style>
